import { GET_APP_EXCLUSIONS, POST_APP_EXCLUSION } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getAppExclusions = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/exclusions/apps/${accountId}`, options))

    if (!response.status || response.status === 404 || response.status === 401 || response.status === 500) {
      console.error(`Received error code ${response.status}`)
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_APP_EXCLUSIONS,
        payload: data
      })
    }
  }
}

export const searchAppExclusion = (label, exe, description, fireSearchSuccess, fireSearchFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { appExe: exe }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(
      window.fetch(`${api}/exclusions/apps/${accountId}/search`, options)
    )

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      log.warn('Error: Failed to fetch search results from application exclusions.')
    } else {
      const { data } = await response.json()
      if (data.length === 0) {
        fireSearchFailure(label, exe, description)
        return false
      } else {
        fireSearchSuccess()
        return true
      }
    }
  }
}

export const postAppExclusion = (applicationName, applicationEXE, applicationDesc, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const accountID = accountId

    const body = { applicationName: applicationName, applicationEXE: applicationEXE, applicationDesc: applicationDesc, createdBy: supervisorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/exclusions/apps/${accountID}`, options))
    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      console.error(`Received response code ${response.status}`)
      fireFailure()
    } else {
      fireSuccess()
      dispatch({
        type: POST_APP_EXCLUSION,
        payload: { ...body }
      })
    }
  }
}

export const deleteAppExclusion = (exclusionID, fireDeleteSuccess, fireDeleteFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const accountID = accountId

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const responseDel = await trackPromise(window.fetch(`${api}/exclusions/apps/${accountID}/${exclusionID}`, options))

    if (!responseDel.status || responseDel.status === 401 || responseDel.status === 404 || responseDel.status === 500) {
      fireDeleteFailure()
    } else {
      fireDeleteSuccess()
    }
  }
}
